import gql from 'graphql-tag';

export const IDENTIFICATION_FRAGMENT = gql`
  fragment identificationFields on User {
    id
    firstname
    fullname
    imgUrl
  }
`;

export const USER_FRAGMENT = gql`
  fragment userFields on User {
    ...identificationFields
    email
    bio
    followers {
      bio
      ...identificationFields
      followers {
        id
      }
    }
    following {
      bio
      ...identificationFields
      followers {
        id
      }
    }
  }

  ${IDENTIFICATION_FRAGMENT}
`;

export const TOPIC_FRAGMENT = gql`
  fragment topicFields on Topic {
    id
    name
    imgUrl
  }
`;

export const QUESTION_FRAGMENT = gql`
  fragment questionFields on Question {
    id
    name
  }
`;
